import identityDatashape from "./identity.datashape";
import shareholderIdentityDatashape from "./shareholderIdentity.datashape";
const baseProfileDatashape =  `...on BasePersonalProfileType {
    entityType
        
    personalDetails
    {
        fullName {
        first
        middle
        last
        }
        motherName {
            first
            middle
            last
        }
        placeOfBirth
        dateOfBirth
        nationality
        countryOfResidence
        maritalStatus
        spouseName {
            first
            middle
            last
            }
        }
        identity {
            ${ identityDatashape }

        }
        professionDetails {
            status
            profession
            employerName
            businessActivity
        }
    }
        ... on BaseCorporationProfileType {
    entityType
        
        corporationDetails {
        name
        businessActivity
        typeOfTradingBusiness
        registrationNumber
        placeOfRegistration
        dateOfRegistration
        countryOfAuthority
        registrationDocument
        legalForm
    }
        shareholders {
            name {
            first
            middle
            last
        }
        percentage
        nationality
        identity {
            ${ shareholderIdentityDatashape }
        }
    }
        businessAddress {
        address
        city
        country
        primaryPhone
        secondaryPhone
        email
        website
    }
}`;
export default baseProfileDatashape